import { useCallback } from 'react';
import { sendReservation } from '../sendReservation';

export function useReserveHouse({
                                  customer,
                                  reservationId,
                                  paymentSelections,
                                  paymentOnBookingPercentage,
                                  securityDepositAmount,
                                  houseId,
                                  additionalInformation,
                                  manualDiscounts,
                                  manualAdditionalPayments,
                                  navigate,
                                  consents,
                                  setLoader
                                }) {
  return useCallback((searchParams) => {
    sendReservation({
      searchParams,
      customer,
      reservationId,
      paymentSelections,
      paymentOnBookingPercentage,
      securityDepositAmount,
      houseId,
      setLoader,
      checkinTime: additionalInformation?.checkinTime,
      checkoutTime: additionalInformation?.checkoutTime,
      reservationComment: additionalInformation?.reservationComment,
      consents,
      manualDiscounts,
      manualAdditionalPayments,
      onSuccess: (reservation) => {
        navigate(
          (reservationId ? '/reservation/' : '/confirmation/') + reservation.id
        );
      }
    });
  }, [
    customer,
    reservationId,
    paymentSelections,
    paymentOnBookingPercentage,
    securityDepositAmount,
    houseId,
    setLoader,
    additionalInformation,
    manualDiscounts,
    manualAdditionalPayments,
    navigate,
    consents
  ]);
}
